module.exports = __webpack_public_path__ + "img/85-af1809.png";